<template>
  <div>
    <PageHeader />
    <SubNav />
    <router-view />
    <div
      v-if="visibleBanner"
      id="cb-cookie-banner"
      class="alert alert-dark text-center mb-0 banner browserWarning"
      role="alert"
    >
      OBS: Verktyget är optimerat för Chrome browser

      <button
        type="button"
        class="btn btn-primary btn-sm ms-3 browserBannerBtn"
        @click="hideBrowserBanner()"
      >
        OK
      </button>
    </div>
  </div>
</template>

<script>
import PageHeader from "./PageHeader/PageHeader";
import SubNav from "./SubNav/SubNav";
export default {
  name: "Layout",
  components: {
    PageHeader,
    SubNav,
  },
  data() {
    return {
      visibleBanner: false
    }
  },
  async mounted(){
    this.initializeBanner();
  },
  methods: {
      initializeBanner() {
      if (
        localStorage.getItem("browserBanner") == null &&
        !this.$browserDetect.isChrome
      )
      this.visibleBanner = true;
    },
    hideBrowserBanner() {
      localStorage.setItem("browserBanner", true);
      this.visibleBanner = false;
    },
  }
};
</script>
<style>
label,
button:not(.mx-btn) {
  float: left;
}
.vdpClearInput {
  margin-top: 20px;
}

.banner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  border-radius: 0;
  background: #424851;
}

.browserWarning {
  color: red;
}

.browserBannerBtn{
  float:right;
  background: #97D058;
  border: none;
}
</style>
